<script setup lang="ts">
import { isInsertingImage } from "@/composable/useImageImport";
import { Z_INDEX_HINT } from "./layouts/constants";

/**
 * Pastille « Ajout de l'image… » en haut du plan, le temps qu'une photo ou
 * une image importée apparaisse (lecture, remise à l'endroit, chargement ODA).
 * Pas de toast dans l'outil dessin, et rien de bloquant : un simple repère.
 */
</script>

<template>
  <Transition name="image-inserting">
    <div
      v-if="isInsertingImage"
      class="image-inserting no-capture canvas-text-scaled text-white d-flex align-items-center gap-2"
      :style="{ zIndex: Z_INDEX_HINT }"
      role="status"
    >
      <span class="spinner-border spinner-border-sm" aria-hidden="true" />
      <span>{{ $t("canvas:tools.image.inserting") }}</span>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.image-inserting {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 14px;
  border-radius: 999px;
  background-color: var(--canvas-bg);
  border: 1px solid var(--canvas-border);
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.spinner-border-sm {
  width: 14px;
  height: 14px;
  border-width: 2px;
}

.image-inserting-enter-active,
.image-inserting-leave-active {
  transition: opacity 0.15s ease;
}

.image-inserting-enter-from,
.image-inserting-leave-to {
  opacity: 0;
}
</style>
